import React from 'react';
import { Link } from 'react-router-dom';

// Internals
import Typography from '../../components/Typography';
import EmptyState from '../../components/EmptyState';
import ConnectedAccounts from './ConnectedAccounts';
import DarkModeSwitch from '../../components/DarkModeSwitch';

// Antd
import { Button, List, PageHeader, Tabs, Tag } from 'antd';

// Icons
import { Clock } from 'react-feather';

const { TabPane } = Tabs;

const ComingSoon = () => (
  <EmptyState
    title="Coming Soon"
    subTitle="We’re working on this page and will release it soon. Contact us if you need any help with
Settings."
    action={
      <Link to="/contact-us">
        <Button size="large">Contact Us</Button>
      </Link>
    }
    icon={<Clock />}
  />
);

export default function Settings() {
  return (
    <div>
      <PageHeader
        ghost={false}
        title={
          <Typography type="display_sm" weight="medium">
            Settings
          </Typography>
        }
      ></PageHeader>

      <Tabs defaultActiveKey="connected-accounts">
        <TabPane tab={<>Profile</>} key="profile">
          <ComingSoon />
        </TabPane>

        <TabPane tab={<>Preferences</>} key="preferences">
          <List className="demo-loadmore-list" itemLayout="horizontal">
            <List.Item>
              <List.Item.Meta title={<DarkModeSwitch />} />
            </List.Item>
          </List>
        </TabPane>

        {/* 
        <TabPane tab={<>Password</>} key="password">
          <ComingSoon />
        </TabPane> */}

        <TabPane
          tab={
            <>
              Team <Tag>4</Tag>
            </>
          }
          key="team"
        >
          <ComingSoon />
        </TabPane>

        {/* 
        <TabPane tab={<>Plan</>} key="plan">
          <ComingSoon />
        </TabPane>

        <TabPane
          tab={
            <>
              Billing <Tag>2</Tag>
            </>
          }
          key="billing"
        >
          <ComingSoon />
        </TabPane>

        <TabPane tab={<>Password</>} key="email">
          <ComingSoon />
        </TabPane>

        <TabPane tab={<>Notifications</>} key="notifications">
          <ComingSoon />
        </TabPane> */}

        <TabPane tab={<>Connected Accounts</>} key="connected-accounts">
          <ConnectedAccounts />
        </TabPane>

        {/* 
        <TabPane tab={<>API</>} key="api">
          <ComingSoon />
        </TabPane> */}
      </Tabs>
    </div>
  );
}
